module.exports = __webpack_public_path__ + "static/CalibreWeb-Light-f5defb3bb15c7f6a2bb45b52ec80e03d.woff2";